import { render } from "./LookupFiltersForm.vue?vue&type=template&id=2c7a9c66&ts=true"
import script from "./LookupFiltersForm.vue?vue&type=script&lang=ts"
export * from "./LookupFiltersForm.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__